import React, { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import { FaInstagram, FaFacebookF, FaYoutube } from 'react-icons/fa';
import logo from './assets/logo.png';
import titleImage from './assets/title.webp';
import './App.css';
import Footer from './components/Footer';

const AboutUs = () => {
  const [scrolled, setScrolled] = useState(false);
  const [mobileMenuOpen, setMobileMenuOpen] = useState(false);
  const [showNavLogo, setShowNavLogo] = useState(false);

  useEffect(() => {
    // Page-specific SEO
    document.title = 'About Celebrity Cuts \u2013 Best Salon in Visakhapatnam';
    const metaDesc = document.querySelector('meta[name="description"]');
    if (metaDesc) metaDesc.setAttribute('content', 'Celebrity Cuts is the best salon in Visakhapatnam, offering professional hair, skin, and beauty services with expert stylists and premium care.');
  }, []);

  useEffect(() => {
    const handleScroll = () => {
      const offset = window.scrollY;
      const isScrolled = offset > 50;

      if (isScrolled !== scrolled) {
        setScrolled(isScrolled);
      }

      setShowNavLogo(offset > 100);
    };

    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, [scrolled]);

  const toggleMobileMenu = () => {
    setMobileMenuOpen(!mobileMenuOpen);
  };

  const closeMobileMenu = () => {
    setMobileMenuOpen(false);
  };

  return (
    <div className="App">
      <nav className={`navbar ${scrolled ? 'scrolled' : ''}`}>
        <div className="nav-center">
          <ul className="nav-menu nav-left-menu desktop-menu">
            <li className="nav-item"><Link to="/" className="nav-link" onClick={closeMobileMenu}>Home</Link></li>
            <li className="nav-item"><Link to="/about" className="nav-link active" onClick={closeMobileMenu}>About Us</Link></li>
          </ul>
          <div className="nav-logo-container visible">
            <div className="nav-logo">
              <Link to="/" onClick={closeMobileMenu}>
                <img src={logo} alt="Celebrity Cuts Logo" />
              </Link>
            </div>
          </div>
          <ul className="nav-menu nav-right-menu desktop-menu">
            <li className="nav-item"><Link to="/services" className="nav-link" onClick={closeMobileMenu}>Services</Link></li>
            <li className="nav-item"><Link to="/gallery" className="nav-link" onClick={closeMobileMenu}>Gallery</Link></li>
          </ul>
          <div className="mobile-menu-icon" onClick={toggleMobileMenu}>
            <div className={`bar ${mobileMenuOpen ? 'open' : ''}`}></div>
            <div className={`bar ${mobileMenuOpen ? 'open' : ''}`}></div>
            <div className={`bar ${mobileMenuOpen ? 'open' : ''}`}></div>
          </div>
        </div>
        <div className="nav-right">
          <ul className="nav-menu right-menu desktop-menu">
            <li className="nav-item social-icons">
              <a href="https://www.instagram.com/celebritycutsinsta/" target="_blank" rel="noopener noreferrer" className="nav-social-link" aria-label="Instagram">
                <FaInstagram className="nav-social-icon" />
              </a>
              <a href="https://www.facebook.com/people/celebrity-cuts/100087441225596/" target="_blank" rel="noopener noreferrer" className="nav-social-link" aria-label="Facebook">
                <FaFacebookF className="nav-social-icon" />
              </a>
              <a href="https://www.youtube.com/@CelebrityCutsinvizag" target="_blank" rel="noopener noreferrer" className="nav-social-link" aria-label="YouTube">
                <FaYoutube className="nav-social-icon" />
              </a>
            </li>
            <li className="nav-item contact-item">
              <Link to="/contact" className="nav-link" onClick={closeMobileMenu}>Contact Us</Link>
            </li>
          </ul>
        </div>
      </nav>

      {mobileMenuOpen && (
        <div className="mobile-menu small-menu">
          <ul className="mobile-nav-menu">
            <li className="nav-item"><Link to="/" className="nav-link" onClick={closeMobileMenu}>Home</Link></li>
            <li className="nav-item"><Link to="/about" className="nav-link active" onClick={closeMobileMenu}>About Us</Link></li>
            <li className="nav-item"><Link to="/services" className="nav-link" onClick={closeMobileMenu}>Services</Link></li>
            <li className="nav-item"><Link to="/gallery" className="nav-link" onClick={closeMobileMenu}>Gallery</Link></li>
            <li className="nav-item"><Link to="/contact" className="nav-link" onClick={closeMobileMenu}>Contact Us</Link></li>
          </ul>
        </div>
      )}

      <main className="page-container">
        <div className="about-us-content">
          <h1 className="page-title animate-fade-in-up">Best Salon in Visakhapatnam for Hair, Skin &amp; Beauty Services</h1>
          <div className="about-section">
            <div className="about-text animate-fade-in-left">
              <p className="lead">Welcome to Celebrity Cuts, the best salon in Visakhapatnam where style meets sophistication. We are dedicated to delivering celebrity-inspired haircuts, styling, and beauty services that enhance your confidence and personal style.</p>
              <p>Our team of professional stylists is committed to creating looks that suit your personality with elegance and precision. With years of experience in the beauty industry, we have mastered the art of transforming everyday styles into stunning appearances that make you feel like a star.</p>
              <p>At Celebrity Cuts, we believe everyone deserves to look and feel their best. As a trusted unisex salon in Vizag, we use only high-quality products and stay updated with the latest trends, techniques, and innovations in hair care and beauty services.</p>
              <p>Our focus is not just on styling, but on providing a premium salon experience through personalized consultation, hygienic practices, and professional service standards.</p>
            </div>
            <div className="about-image animate-fade-in-right">
              <img
                src={titleImage}
                alt="Celebrity Cuts Title"
                className="title-image"
                style={{
                  width: '100%',
                  height: '100%',
                  objectFit: 'cover',
                  borderRadius: '10px',
                  boxShadow: '0 4px 20px rgba(0, 0, 0, 0.5)',
                  transform: 'scale(0.95)',
                  transition: 'transform 0.5s ease, box-shadow 0.5s ease'
                }}
                onMouseOver={(e) => e.currentTarget.style.transform = 'scale(1)'}
                onMouseOut={(e) => e.currentTarget.style.transform = 'scale(0.95)'}
              />
            </div>
          </div>

          <div className="our-mission animate-fade-in-up delay-200">
            <h2>Our Mission</h2>
            <p>To provide exceptional hair care services in a luxurious environment, where clients can relax and trust that they're receiving the best possible care for their hair.</p>
          </div>

          <div className="why-choose-us">
            <h2 className="animate-fade-in">Why Choose Us</h2>
            <div className="features-grid">
              <div className="feature animate-fade-in-up delay-100">
                <div className="feature-icon">✂️</div>
                <h3>Expert Stylists</h3>
                <p>Our team consists of highly trained professionals with years of experience in the industry.</p>
              </div>
              <div className="feature animate-fade-in-up delay-200">
                <div className="feature-icon">💈</div>
                <h3>Premium Products</h3>
                <p>We use only the highest quality products to ensure the best results for your hair.</p>
              </div>
              <div className="feature animate-fade-in-up delay-300">
                <div className="feature-icon">✨</div>
                <h3>Luxury Experience</h3>
                <p>Enjoy a premium salon experience in our elegant and comfortable environment.</p>
              </div>
            </div>
          </div>
        </div>
      </main>
    </div>
  );
};

export default AboutUs; 
